import { AlertCircle, ChevronRight } from 'lucide-react'
import { ReactNode } from 'react'
import { Button } from './button'

function renderArrayValue(value: string | string[]): ReactNode {
    if (Array.isArray(value)) {
        return (
            <div className="flex flex-col gap-2">
                {value.map((item, idx) => (
                    <div key={idx}>{item}</div>
                ))}
            </div>
        )
    }
    return value
}

export interface DetailListItemProps {
    label: string
    value: string | string[]
    onAction?: () => void
    isNotProvided?: boolean
    notProvidedMessage?: string
    actionLabel?: string
}

export function DetailListItem({
    label,
    value,
    onAction,
    isNotProvided = false,
    notProvidedMessage = 'Not provided',
    actionLabel = 'Add',
}: DetailListItemProps) {
    const showAction = isNotProvided && onAction

    return (
        <div className="self-stretch flex justify-between items-center">
            <div className="flex flex-col justify-start items-start gap-1">
                <div className="justify-start text-black text-sm font-medium leading-5">{label}</div>
                {isNotProvided ? (
                    <div className="inline-flex justify-start items-center gap-2">
                        <AlertCircle className="w-6 h-6 text-yellow-600" />
                        <div className="justify-start text-content-secondary text-sm font-normal font-['Inter'] leading-5">
                            {notProvidedMessage}
                        </div>
                    </div>
                ) : (
                    <div className="justify-start text-content-secondary text-sm font-normal leading-5">
                        {renderArrayValue(value)}
                    </div>
                )}
            </div>
            {showAction && (
                <Button
                    onClick={onAction}
                    variant="ghost"
                    className="flex justify-center items-center px-6 py-2 gap-2 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-primary transition-colors"
                >
                    <div className="justify-start text-black text-sm font-medium font-['Inter'] underline leading-6">
                        {actionLabel}
                    </div>
                    <ChevronRight className="w-4 h-4 text-black" />
                </Button>
            )}
        </div>
    )
}
